import { createMultiStyleConfigHelpers, ComponentStyleConfig } from '@chakra-ui/react';
import { inputAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    borderRadius: 'lg',
  },
  addon: {
    borderRadius: 'lg',
  },
});

const variants = {
  outline: {
    field: {
      bgColor: 'chakra-body-bg',
      borderColor: 'chakra-border-color',
      borderWidth: '2px',
    },
    addon: {
      bgColor: 'chakra-body-bg',
      borderColor: 'chakra-border-color',
      borderWidth: '2px',
    },
  },
};

export const inputTheme: ComponentStyleConfig = defineMultiStyleConfig({
  baseStyle,
  variants,
});
